<template>
  <div class="ui-content dashboard leader-sub bookmark-14-feb">
    <div class="user-data">
      <v-row>
        <v-col cols="12" sm="12" class="attempted-questions-header-col">
          <div class="attempted-questions-header bookmark-filter">
            <div class="att-header-col">
              <div class="show-drop-down drop-I-new single-select">
                <div class="field-data">
                  <v-select v-model="selectedSubject" :items="subjects" label="Subject" hide-details
                    class="fix-350-width select-chapter-margin-ps"></v-select>
                </div>
              </div>
              <div class="show-drop-down">
                <div class="field-data">
                  <multi-select allText="All Chapters" :onChange="chapterSelected" :items="chapters" label="Chapter"
                    hide-details widthcss="fix-200"></multi-select>
                </div>
              </div>
              <div class="show-drop-down">
                <div class="field-data">
                  <multi-select allText="All Topics" :items="topics" label="Topic" :onChange="topicSelected"
                    widthcss="fix-200"></multi-select>
                </div>
              </div>
            </div>
            <div class="att-header-col">
              <div class="show-drop-down drop-last-new">
                <div class="label-data">{{ routeName == 'attempted-questions' ? 'Attempted In:' : 'Source:'}}</div>
                <div class="field-data">
                  <multi-select allText="All" :items="tTypes" label="All" :onChange="onTestTypeChange"
                    widthcss="fix-200"></multi-select>
                </div>
              </div>
            </div>
          </div>
        </v-col>
      </v-row>
    </div>
    <div>
      <BookmarkedAttemptedQuesList :checkStudentUpgraded="checkStudentUpgraded" :subjectId="selectedSubject"
        :chapterId="selectedChapterID" :topicId="selectedTopicID" :testTypeId="selectedTestTypes"
        :functionCalls="this.$route.name" />
    </div>
    <AlertBox :width="modalwidth" :onClose="onClose" :component="cComponent" :status="status" :data="alertBoxData" />
  </div>
</template>

<script>
import BookmarkedAttemptedQuesList from "@/components/student/BoostUp/BookmarkedAttemptedQuesList";
// import PreviousYearTest from "@/components/student/Tests/PastTests/PreviousYearTest.vue";
import UpgradeToPracticeSessionPopUp from "@/components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp.vue";
import { mapState, mapMutations, mapActions } from "vuex";
import constants from "@/utils/constants.js";
import moment from "moment";
import { showUpgradeModal } from "@/utils/upgradeUtils.js";
export default {
  name: "BookmarkedQuestions",
  components: {
    BookmarkedAttemptedQuesList,
    UpgradeToPracticeSessionPopUp,
  },
  mounted() {
    this.$root.showLoader = true;
    this.checkSessionData();
    localStorage.removeItem("prevPath");
    localStorage.setItem('prevPath', this.$route.name);
    this.routeName = this.$route.name;
  },
  computed: {
    ...mapState("userStore", ["user"]),
  },
  data() {
    return {
      testTypesList: [{ text: "Institute Tests", value: "institute" }],
      subjects: [],
      selectedSubject: null,
      chapters: [],
      topics: [],
      tTypes: [],
      selectedChapterID: null,

      selectedTopicID: [],
      selectedTestTypes: [],
      upgradeToPracticeSession: null,
      cComponent:
        "components/student/Tests/PastTests/UpgradeToPracticeSessionPopUp",
      status: false,
      modalwidth: "500px",
      alertBoxData: {},
      routeName: '',
      loadQuestions: false,
      isFirstLoading: true,
    };
  },
  methods: {
    ...mapMutations("app", ["addBreadCrumbChilde"]),
    ...mapActions({
      getDataTreeWithLevel: "utilStore/getDataTreeWithLevel",
      getSubjectBatchWise: "resultStore/getSubjectBatchWise",
      getTestTypes: "utilStore/getTestTypes",
      getBookmarkQuestion: "testStore/getBookmarkQuestion",
    }),
    checkSessionData() {
      let rp = this.$route; // route params
      let crd = this.getCurrentRouteDetails(rp.name);
      if (rp.params.resetPage || !crd.routeName) {
        let tabDetail = {
          default: {
            page: 1,
            orderBy: {
              field: "test_name",
              order: "ASC"
            },
            subject_id: null,
            selectedChapterID: null,
            selectedTopicID: [],
            selectedTestTypes: [],
            question_type: [],
            response: [],
          }
        };
        let routeDetails = {
          routeName: rp.name,
          selectedTab: 'default',
          tabDetails: tabDetail
        }
        this.setRouteDetails(routeDetails);
      }
      this.defaultData();
    },
    updateCurrentRouteDetails(fieldName, fieldValue) {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      crd.tabDetails[crd.selectedTab][fieldName] = fieldValue;
      this.setRouteDetails(crd);
    },
    defaultData() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);

      if (crd) {
        this.selectedSubject = crd.tabDetails[crd.selectedTab].subject_id;
        this.selectedChapterID = crd.tabDetails[crd.selectedTab].selectedChapterID;
        this.selectedTopicID = crd.tabDetails[crd.selectedTab].selectedTopicID;
        this.selectedTestTypes = crd.tabDetails[crd.selectedTab].selectedTestTypes;
      }
      this.getSubjects();
      this.requestGetTestTypes();
    },
    getSubjects() {
      let reqData = {
        student_id: this.user.id,
        batch_id: this.user.batch_id,
      };
      if (this.isParent) {
        reqData.student_id = this.studentId;
        reqData.batch_id = this.selectedStudent.batchId;
      }
      let me = this;
      this.getSubjectBatchWise(reqData)
        .then((response) => {
          this.subjects = response.map((s) => {
            return {
              text: s.title,
              value: s.id,
              selected: false,
            };
          });

          // me.$root.showLoader = false;
        })
        .catch((err) => {
          console.log(err);
        });
    },

    //Chapter Function
    subjectSelected() {
      this.selectedChapterID = null;
      this.selectedTopicID = null;
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedChapterID = crd.tabDetails[crd.selectedTab].selectedChapterID;
      }
      let reqData = {
        level: 3,
        parent: this.selectedSubject,
      };
      this.topics = [];
      this.$root.showLoader = true;
      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          // this.$root.showLoader = false;
          this.chapters = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            c.checked = this.selectedChapterID && this.selectedChapterID.includes(x.id) ? true : false;
            return c;
          });
        })
        .catch((err) => {
          // this.$root.showLoader = false;
        });
    },
    //Topic Function
    chapterSelected(chapterID) {
      this.selectedChapterID = chapterID;
      this.selectedTopicID = null;
    },
    getChapters() {
      let reqData = {
        level: 4,
        parent_ids: this.selectedChapterID,
      };
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedTopicID = crd.tabDetails[crd.selectedTab].selectedTopicID.length ? crd.tabDetails[crd.selectedTab].selectedTopicID : null
      }
      // this.$root.showLoader = true;

      this.getDataTreeWithLevel(reqData)
        .then((response) => {
          // this.$root.showLoader = false;
          this.topics = response.map((x) => {
            let c = {};
            c.text = x.title;
            c.value = x.id;
            c.checked = this.selectedTopicID && this.selectedTopicID.includes(x.id) ? true : false;
            return c;
          });
        })
        .catch((err) => {
          this.$root.showLoader = false;
        });

    },
    //Test Type Function
    requestGetTestTypes() {
      let routeName = this.$route.name;
      let crd = this.getCurrentRouteDetails(routeName);
      if (crd) {
        this.selectedTestTypes = crd.tabDetails[crd.selectedTab].selectedTestTypes;
      }
      if (this.$route.name == 'attempted-questions') {
        this.tTypes = constants.TEST_TYPES_AQ.map((x) => {
          return {
            text: x.title,
            value: x.value,
            checked: this.selectedTestTypes && this.selectedTestTypes.includes(x.id) ? true : false
          };
        });
      } else {
        this.tTypes = constants.TEST_TYPES_BQ.map((x) => {
          return {
            text: x.title,
            value: x.value,
            checked: this.selectedTestTypes && this.selectedTestTypes.includes(x.id) ? true : false
          };
        });
      }
    },
    topicSelected(topicId) {
      this.selectedTopicID = topicId;
      this.updateCurrentRouteDetails('selectedTopicID', this.selectedTopicID);
    },
    onTestTypeChange(selectedTest) {
      this.selectedTestTypes = selectedTest;
      this.updateCurrentRouteDetails('selectedTestTypes', this.selectedTestTypes);
    },
    redirectTo(route) {
      this.$router.push({
        name: route,
      });
    },
  
    onClose(data) {
      this.status = data.status;
      
      // Handle upgrade confirmation modal response
      if (data.openPaymentModal) {
        this.cComponent = 'components/student/UpgradeToGold/GstChargesPopUp';
        this.modalwidth = '500px';
        this.status = true;
        this.alertBoxData = data.paymentData;
        return;
      }
      
      if (data && data.redirectTo) {
        this.redirectTo(data.redirectTo);
      }
    },
    checkStudentUpgraded() {
      this.status = this.checkStudentUpgradedHelper(
        this.user.subscription_details
      );
      if( this.status ) {
        showUpgradeModal(this);
      }
      return this.status;
    },

  },
  watch: {
    selectedSubject(val) {
      if (val) {
        this.subjectSelected()
        if (!this.isFirstLoading) {          
          this.selectedChapterID = []
          this.selectedTopicID = null
          this.updateCurrentRouteDetails('selectedTopicID', [])
        }
        this.updateCurrentRouteDetails('subject_id', val)
        // this.updateCurrentRouteDetails('subject_id', val)
        setTimeout(()=>{
          this.isFirstLoading=false
        },500)
      }
    },
    selectedChapterID(val) {
      if (val) {
        this.getChapters()

        if (!this.isFirstLoading) {
          this.selectedTopicID = []
          this.updateCurrentRouteDetails('selectedTopicID', [])
  
        }
        this.updateCurrentRouteDetails('selectedChapterID', val);
        setTimeout(()=>{
          this.isFirstLoading=false
        },500)
      }
    }
  }
};
</script>
<style scoped>
.single-select .field-data {
  width: 200px;
  min-height: 40px !important;
  background: rgba(0, 0, 0, 0.03) !important;
  border-radius: 4px 4px 0px 0px;
  box-shadow: none !important;
  border-bottom: 2px solid #d2d2d2;
}
</style>
